import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { apiPost } from '../lib/api';
import type { TicketDetail } from '../types';

/**
 * Marquage « hors TMA » (mode projet) depuis la fiche du point, retour 6 du
 * rapport n°33. Agents Digital Team non restreints seulement (is_admin, comme
 * l'API). Le temps se saisit toujours sur le point ; les statistiques de la V2
 * le mettent à part de la TMA du client.
 */
export function HorsTmaToggle({ ticket, onChanged }: { ticket: TicketDetail; onChanged: () => void }) {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  if (!user?.is_admin || ticket.hors_tma === undefined) return null;
  const on = ticket.hors_tma === true;

  async function toggle() {
    const msg = on
      ? 'Remettre ce point dans la TMA du client ? Son temps comptera de nouveau dans les statistiques du client.'
      : 'Marquer ce point « hors TMA » (mode projet) ? Son temps sortira des statistiques TMA du client (la page stats du V1 le compte toujours).';
    if (!window.confirm(msg)) return;
    setErr(null);
    setBusy(true);
    try {
      await apiPost(`/api/tickets/${ticket.display_id}/hors-tma`, { hors_tma: !on });
      onChanged();
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Erreur');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ marginTop: 6 }}>
      <button
        type="button"
        onClick={toggle}
        disabled={busy}
        aria-pressed={on}
        style={{
          fontSize: 'var(--fs-xs)',
          padding: '4px 8px',
          borderRadius: 4,
          cursor: 'pointer',
          background: 'transparent',
          border: '1px solid var(--border)',
          color: 'var(--accent)',
        }}
      >
        {on ? 'Retirer « hors TMA »' : 'Marquer hors TMA'}
      </button>
      {err && <div style={{ color: 'var(--danger)', fontSize: 'var(--fs-xs)', marginTop: 4 }}>{err}</div>}
    </div>
  );
}
